import updateExamModuleDoc from '../../api/examModules/updateExamModuleDoc';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useUpdateExamModule() {
  const {fn, loading, error} = useFunctionWrap(updateExamModuleDoc);

  return {
    updateExamModule: fn,
    loading,
    error,
  };
}
